/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tour_Review_DescInputs */

const en_wc_tour_review_desc = /** @type {(inputs: Wc_Tour_Review_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track changes, comment balloons, accept/reject and spelling & grammar as you type.`)
};

/**
* | output |
* | --- |
* | "Track changes, comment balloons, accept/reject and spelling & grammar as you type." |
*
* @param {Wc_Tour_Review_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tour_review_desc = /** @type {((inputs?: Wc_Tour_Review_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tour_Review_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tour_review_desc(inputs)
});
export { wc_tour_review_desc as "wc.tour.review.desc" }